module.exports = __webpack_public_path__ + "img/full6-min.be0bfddc.png";